module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boyindex"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "24px",
      "width": "100%",
      "text-align": "center",
      "color": "#fff",
      "font-weight": "600"
    }
  }, [_vm._v("\n      登录中心\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('van-field', {
    staticStyle: {
      "font-size": "18px!important",
      "border-radius": "10px"
    },
    attrs: {
      "placeholder": "请输入用户账号"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('van-field', {
    staticStyle: {
      "font-size": "18px!important",
      "border-radius": "10px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "item",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('van-field', {
    staticStyle: {
      "font-size": "18px!important",
      "border-top-left-radius": "10px",
      "border-bottom-left-radius": "10px"
    },
    attrs: {
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.captcha),
      callback: function($$v) {
        _vm.captcha = $$v
      },
      expression: "captcha"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "getImgCaptcha",
    staticStyle: {
      "border-top-right-radius": "10px",
      "border-bottom-right-radius": "10px"
    },
    attrs: {
      "src": _vm.imgCaptcha,
      "alt": ""
    },
    on: {
      "click": _vm.getImgCaptcha
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('van-button', {
    staticStyle: {
      "border-radius": "10px",
      "font-size": "18px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("立即登录")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d041680"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/driverSchool/login.vue
// module id = 472
// module chunks = 1